// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:30Z                      #

// ##############################################################


/**
 * 
 */
enum Role {
    PODEPISUJICI = 'PODEPISUJICI', 
    SCHVALUJICI = 'SCHVALUJICI', 
    PREDKLADATEL = 'PREDKLADATEL'
};
export default Role;

